import React from "react";
import { useLocation } from "react-router-dom";
import ESModuleSubtopic from "../ESModuleSubtopic";

const MicrocontrollerArchitecture = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || {
    subtopics: [],
    subjectPath: "",
  };

  return (
    <ESModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Micro-controller architecture - 8051, PIC, and ARM"
      videos={[
        "https://www.youtube.com/embed/h1k-b6lp7K8",
        "https://www.youtube.com/embed/F43WzRerAOU",
        "https://www.youtube.com/embed/E2uADpID6oU",
        "https://www.youtube.com/embed/hZDReT0vzBU",
        "https://www.youtube.com/embed/RrPfzHwzOGo",
        "https://www.youtube.com/embed/5fESTph5gA8",
      ]}
      takeaways={[]}
      questions={[
        "1)Explain the features and architecture of 8051 Microcontroller with the help of neat diagram",
        "2)Describe various modes of operations of ARM.",
        "3)State the design challenges and characteristics of an embedded system? Draw the schematic diagram and write an embedded program using 8051 for the following: A door sensor is connected to the P1.1 and buzzer is connected to P1.7. Monitor the door sensor and when it opens, sound the buzzer?",
        "4)write a short note on the following? i. ARM Processor Programmers model ii. PIC microcontroller",
        "5) write a 8051 C program to toggle only P2.5 continuously every 270 msec. Use timer 0, mode 2 to create delay?",
        "6) How do the different execution modes in ARM architecture optimise system performance, enable efficient multitasking and ensure robust security in embedded and real-time operations?"
      ]}
      exampleVideos={[]}
    />
  );
};

export default MicrocontrollerArchitecture;
